import { createClient } from '@sanity/client'

export const client = createClient({
    
    projectId: 'c78div9r',
    dataset: 'production'
    
})
